import React from "react";
import { useLazyLoadQuery, graphql } from "react-relay";
import StatTable from "../../../../../StatTable";
import { isSiteAdmin, isToolSub } from "../../../../../../AuthUtils";
import { Redirect } from "react-router-dom";
import Button from "../../../../../Button";

const GET_ODDS = graphql`
  query NFLOddsReportTableQuery {
    whoAmI {
      groups {
        name
      }
    }

    nflCurrentWeekOdds {
      team {
        abbreviation
        name
      }

      opp {
        abbreviation
        name
      }

      home

      pointSpread
      pointSpreadOdds

      gameTotal
      impliedTeamTotal

      moneylineOdds
    }
  }
`;

export default function NFLOddsReportTable(props) {
  const queryData = useLazyLoadQuery(GET_ODDS);

  if (!queryData.whoAmI || !isToolSub(queryData.whoAmI.groups)) {
    return <Redirect to="/memberships" />;
  }

  let data = React.useMemo(() => {
    return queryData.nflCurrentWeekOdds.map((row) => {
      let editableRow = { ...row };

      editableRow.team = row.team.abbreviation + " " + row.team.name;
      editableRow.opp = row.opp.abbreviation + " " + row.opp.name;
      editableRow.homeAway = row.home ? "Home" : "Away";

      return editableRow;
    });
  }, [queryData]);

  let columns = [
    {
      Header: "Team",
      accessor: "team",
    },
    {
      Header: "Opp",
      accessor: "opp",
    },
    {
      Header: "H/A",
      accessor: "homeAway",
    },
    {
      Header: "ML Odds",
      accessor: "moneylineOdds",
    },
    {
      Header: "Spread",
      accessor: "pointSpread",
    },
    {
      Header: "Spread Odds",
      accessor: "pointSpreadOdds",
    },
    {
      Header: "Game Total",
      accessor: "gameTotal",
    },
    {
      Header: "Implied TT",
      accessor: "impliedTeamTotal",
    },
  ];

  return (
    <div>
      <div className="nfl-odds-report-table-container">
        <StatTable data={data} columns={columns} showDKPlayerInfo={(p) => {}} />
      </div>
    </div>
  );
}
